/**
 * @generated SignedSource<<1b063ed7fe358b9f7af4953dc70bc371>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
export type LabelLiftRequest = {
  brandId: string;
  kpi: KPI;
  labelName?: string | null;
  labelType?: LabelType | null;
  performanceDateRange?: DateRangeInput | null;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type useSafeLabelLiftQueryQuery$variables = {
  input: LabelLiftRequest;
  skip: boolean;
};
export type useSafeLabelLiftQueryQuery$data = {
  readonly labelLiftData?: ReadonlyArray<{
    readonly adsCount: number;
    readonly kpiPresent: number;
    readonly lift: number;
    readonly period: string;
    readonly spendPresent: number;
  }>;
};
export type useSafeLabelLiftQueryQuery = {
  response: useSafeLabelLiftQueryQuery$data;
  variables: useSafeLabelLiftQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LabelLiftData",
        "kind": "LinkedField",
        "name": "labelLiftData",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "period",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lift",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "spendPresent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kpiPresent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSafeLabelLiftQueryQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSafeLabelLiftQueryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f8e762b0ab658ee7ead6f132ee32542c",
    "id": null,
    "metadata": {},
    "name": "useSafeLabelLiftQueryQuery",
    "operationKind": "query",
    "text": "query useSafeLabelLiftQueryQuery(\n  $input: LabelLiftRequest!\n  $skip: Boolean!\n) {\n  labelLiftData(input: $input) @skip(if: $skip) {\n    period\n    lift\n    adsCount\n    spendPresent\n    kpiPresent\n  }\n}\n"
  }
};
})();

(node as any).hash = "3848d5413b4f36ca8d7cdf10954a935e";

export default node;
